import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../../auth/service/cities.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ICity } from "app/auth/models/cities";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-cities-add",
  templateUrl: "./cities-form.component.html",
  styleUrls: ["./cities-form.component.scss"],
})
export class CitiesFormComponent implements OnInit {
  public contentHeader: IContentHeader;

  public formGroup: FormGroup;

  public isEdit: boolean = false;

  public cities: ICity[] = [];

  public city_id: number = 0;

  public showErrors: boolean = false;

  constructor(
    public _citiesService: CitiesService,
    public _formBuilder: FormBuilder,
    private activated_route: ActivatedRoute,
    private router: Router,
    private _utilService: UtilsService,
  ) {
    this.formGroup = this._formBuilder.group({
      name: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      initials: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
      province: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      region: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      is_main: new FormControl(""),
    });

    this.activated_route.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        this.isEdit = true;
        this.city_id = Number(params.id);
      }
    });
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: this.isEdit ? "EDIT_CITY" : "ADD_CITY",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.CITIES",
            isLink: true,
            link: "/dashboard/cities",
          },
          {
            name: this.isEdit ? "EDIT" : "ADD",
            isLink: false,
          },
        ],
      },
    };

    if (this.isEdit) {
      const cities: ICity = await this._citiesService.get(this.city_id);

      if (!cities) {
        await this.router.navigateByUrl("/dashboard/cities");
      } else {
        this.formGroup.patchValue({
          name: cities.name,
          initials: cities.initials,
          province: cities.province,
          region: cities.region,
          is_main: Boolean(cities.is_main),
        });
      }
    }
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async create() {
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }
    let isMainValue = 0;
    if (this.formGroup.value.is_main) {
      isMainValue = 1;
    }
    let data: ICity = {
      name: this.formGroup.value.name,
      initials: this.formGroup.value.initials.toUpperCase(),
      province: this.formGroup.value.province,
      region: this.formGroup.value.region,
      is_main: isMainValue,
    };
    await this._citiesService
      .create(data)
      .then(async () => {
        await this.router.navigateByUrl("/dashboard/cities");
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_CITY" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_UPLOAD_CITY" }));
  }

  async update() {
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }
    let isMainValue = 0;
    if (this.formGroup.value.is_main) {
      isMainValue = 1;
    }
    const data: ICity = {
      name: this.formGroup.value.name,
      initials: this.formGroup.value.initials.toUpperCase(),
      province: this.formGroup.value.province,
      region: this.formGroup.value.region,
      is_main: isMainValue,
    };
    await this._citiesService
      .update(this.city_id, data)
      .then(async () => {
        await this.router.navigateByUrl("/dashboard/cities");
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_CITY" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_CITY" }));
  }
}
